// extracted by mini-css-extract-plugin
export default {"map":"k8eFGo","iframe":"LkJ7XF","staticMap":"novU7z"};